import Vue from 'vue'

class ProformaInvoiceSyncTaskRepository {

  controller = {}

  get(taskId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/proforma-invoice-sync-tasks/${taskId}`,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  search(data, instanceId = 'default') {
    return new Promise((resolve, reject) => {
      if (this.controller[instanceId]) {
        this.controller[instanceId].abort()
      }
      this.controller[instanceId] = new AbortController()

      Vue.auth.fetch({
        url: '/api/proforma-invoice-sync-tasks/search',
        method: 'post',
        data,
        signal: this.controller[instanceId].signal,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default new ProformaInvoiceSyncTaskRepository()
